import { render } from "./BetConfigTable.vue?vue&type=template&id=c6a84b66"
import script from "./BetConfigTable.vue?vue&type=script&lang=js"
export * from "./BetConfigTable.vue?vue&type=script&lang=js"
script.render = render

export default script